export default __webpack_public_path__ + "static/upwork-fb9db2d451d96250216425b36e2b195f.png";